module.exports = __webpack_public_path__ + "static/media/okc-logo.49d52de5.png";